export const zones = [
  {
    id: 'zone-hall',
    name: '综合爆料大厅',
    tag: '综合',
    hot: 9820,
    summary: '全站流量最高的大厅，各类线索在这里集中涌现，适合快速了解今天讨论什么。',
    meta: '今日新增 218 条线索',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20abstract%20warm%20amber%20and%20vermilion%20geometric%20shapes%20on%20cream%20paper%20background%2C%20soft%20natural%20light%2C%20minimal%20high%20detail%2C%20clean%20composition&width=800&height=600&orientation=landscape&seq=baoliao-zone-01',
  },
  {
    id: 'zone-star',
    name: '艺人动态讨论区',
    tag: '娱乐',
    hot: 8640,
    summary: '聚焦影视综艺与艺人行程话题，讨论节奏快、更新频率高，评论区观点交锋密集。',
    meta: '今日新增 176 条线索',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20abstract%20stage%20spotlight%20warm%20cream%20background%20minimal%20geometric%20shapes%2C%20soft%20natural%20light%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=600&orientation=landscape&seq=baoliao-zone-02',
  },
  {
    id: 'zone-tech',
    name: '数码新品情报局',
    tag: '科技',
    hot: 7310,
    summary: '围绕即将发布的新品与行业动向展开，常见爆料搭配参数推测与真机体验反馈。',
    meta: '今日新增 94 条线索',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20abstract%20circuit%20and%20device%20silhouette%20warm%20cream%20background%20minimal%20geometric%20shapes%2C%20soft%20light%2C%20high%20detail%2C%20clean%20composition&width=800&height=600&orientation=landscape&seq=baoliao-zone-03',
  },
  {
    id: 'zone-finance',
    name: '财经内幕茶话会',
    tag: '财经',
    hot: 6180,
    summary: '关注市场变化与公司动态，讨论偏理性，常见数据梳理与时间线复盘。',
    meta: '今日新增 71 条线索',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20abstract%20rising%20chart%20lines%20warm%20cream%20paper%20background%20minimal%20geometric%20shapes%2C%20soft%20natural%20light%2C%20high%20detail%2C%20clean%20composition&width=800&height=600&orientation=landscape&seq=baoliao-zone-04',
  },
  {
    id: 'zone-consumer',
    name: '消费维权广场',
    tag: '生活',
    hot: 5240,
    summary: '分享消费踩坑与售后处理经验，帖子多附带完整沟通记录，实用性强。',
    meta: '今日新增 63 条线索',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20abstract%20shopping%20bag%20and%20receipt%20shapes%20warm%20cream%20background%20minimal%20geometric%2C%20soft%20natural%20light%2C%20high%20detail%2C%20clean%20composition&width=800&height=600&orientation=landscape&seq=baoliao-zone-05',
  },
  {
    id: 'zone-sports',
    name: '赛事前线讨论区',
    tag: '体育',
    hot: 4360,
    summary: '赛前预测、实时战报与转会传闻都在这里，赛后复盘帖往往质量很高。',
    meta: '今日新增 48 条线索',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20abstract%20stadium%20arc%20and%20motion%20lines%20warm%20cream%20background%20minimal%20geometric%20shapes%2C%20soft%20light%2C%20high%20detail%2C%20clean%20composition&width=800&height=600&orientation=landscape&seq=baoliao-zone-06',
  },
];